<template>
  <DialogWrapper
    class="confirm-delete-dialog"
    close-on-cancel
    :titleI18nKey="`${i18nPrefix}.title.tip`"
    :show.sync="show"
    @save="handleSave"
  >
    <div>{{ $t(`${i18nPrefix}.message.deleteSearchTemplate`) }}</div>
  </DialogWrapper>
</template>

<script>
import DialogWrapper from '@/components/dialog/dialogWrapper.vue'

export default {
  components: {
    DialogWrapper
  },
  props: {

  },
  data () {
    const i18nPrefix = 'admin.application.applicantList'
    return {
      i18nPrefix,
      show: false
    }
  },
  computed: {

  },
  created () {

  },
  methods: {
    openDialog () {
      this.show = true
    },
    closeDialog () {
      this.show = false
    },
    handleSave () {
      this.$emit('save')
      this.closeDialog()
    }
  }
}

</script>

<style lang='scss' scoped>
</style>
